var _path, _path2, _path3, _path4, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceMms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.652 26.855c6.81.28 12.558-4.987 12.839-11.763.281-6.777-5.011-12.497-11.82-12.777C9.86 2.035 4.111 7.302 3.83 14.08c-.114 2.749.689 5.324 2.139 7.433l-2.716 6.474 6.962-2.636a12.335 12.335 0 0 0 5.436 1.505z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.573 21.645.703.261.142-.384-.245-.327-.6.45zM2 28.569l-.703-.261-.608 1.635 1.605-.684-.294-.69zm7.204-3.072.333-.672-.31-.154-.317.136.294.69zm18.018-11.575c0 6.72-5.475 12.173-12.236 12.173v1.5c7.582 0 13.736-6.118 13.736-13.672h-1.5zM14.986 1.75c6.76 0 12.236 5.453 12.236 12.172h1.5C28.722 6.368 22.568.25 14.986.25v1.5zM2.75 13.922C2.75 7.203 8.225 1.75 14.986 1.75V.25C7.403.25 1.25 6.368 1.25 13.922h1.5zm2.423 7.273a12.074 12.074 0 0 1-2.423-7.273h-1.5c0 3.064 1.013 5.893 2.723 8.173l1.2-.9zm-2.47 7.635 2.573-6.924-1.406-.522-2.573 6.924 1.406.522zm6.207-4.023-7.204 3.072.588 1.38 7.204-3.073-.588-1.38zm6.076 1.288c-1.96 0-3.81-.458-5.45-1.27l-.665 1.344a13.735 13.735 0 0 0 6.115 1.426v-1.5z",
    fill: "url(#jd6u4gg6ba)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.115 15.49a.75.75 0 0 0 1.15.965l-1.15-.964zm3.71-3.25.576-.48a.75.75 0 0 0-1.151-.002l.574.482zm5.384 7.64a.75.75 0 0 0 1.152-.96l-1.152.96zm-7.945-3.425 3.135-3.732-1.15-.965-3.134 3.733 1.15.964zm1.984-3.735 5.96 7.16 1.153-.96-5.96-7.16-1.153.96z",
    fill: "#00A6CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.81 14.07a.75.75 0 0 0 1.167.944l-1.167-.944zm5.465-5.562.558-.501a.75.75 0 0 0-1.14.03l.582.47zm4.17 5.768a.75.75 0 1 0 1.116-1.002l-1.116 1.002zm-8.468.738 4.881-6.034-1.166-.944-4.882 6.034 1.167.944zm3.74-6.005 4.728 5.267 1.116-1.002-4.728-5.267-1.116 1.002z",
    fill: "#00A6CE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.646,
    cy: 7.953,
    rx: 1.36,
    ry: 1.354,
    fill: "#00A6CE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jd6u4gg6ba",
    x1: 14.986,
    y1: 1,
    x2: 14.986,
    y2: 28.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceMms);
export default __webpack_public_path__ + "static/media/serviceMMS.4544b8569c61f7899b83dc06d446f1b9.svg";
export { ForwardRef as ReactComponent };